<template>
  <div>

      <div class="row col-12">
        <div class="col-md-3 col-sm-3" v-if="!hideMaxAvgMin">
          <va-card class="d-flex align-items-center text-center" style="min-height: 170px; height: 100%">
            <p class="mb-0"><span class="is-bold">{{$t('dashboard_new_evollu.parameters.titles.max_value')}}:</span></p>
            <p class="mb-0" v-for="(value, name) in statsData"><span>{{$t(`dashboard_new_evollu.measurement_types.${name}_short`)}}: {{statsData[name].max}}</span></p>
            <p class="mb-0"><span class="is-bold">{{ $t('dashboard_new_evollu.parameters.titles.medium_value') }}: </span></p>
            <p class="mb-0" v-for="(value, name) in statsData"><span>{{$t(`dashboard_new_evollu.measurement_types.${name}_short`)}}: {{statsData[name].avg}}</span></p>
            <p class="mb-0"><span class="is-bold">{{ $t('dashboard_new_evollu.parameters.titles.minimum_value') }}: </span></p>
            <p class="mb-0" v-for="(value, name) in statsData"><span>{{$t(`dashboard_new_evollu.measurement_types.${name}_short`)}}: {{statsData[name].min}}</span></p>
          </va-card>
        </div>

        <div :class="{'col-md-9': !hideMaxAvgMin, 'col-sm-9': !hideMaxAvgMin, 'col-md-12': hideMaxAvgMin, 'col-sm-12': hideMaxAvgMin}">
          <va-card style="min-height: 170px; height: 100%">
            <va-tabs v-model="tabValue" style="border-width: 2px">
              <va-tab
                v-for="tab in viewType"
                :key="tab"
              >
                {{ $t(`dashboard_new_evollu.parameters.titles.${tab}`)}}
              </va-tab>
            </va-tabs>
            <v-client-table
              v-if="tabValue === 0"
              id="dataTable"
              ref="dataTable"
              name="dataTable"
              :data="data"
              :columns="actionsAddedToColumns"
              :options="tableOptions"
              @row-click="handleShowProfileModal"
            >
              <span slot="created_at" slot-scope="{row}">
                {{row.created_at}}
              </span>
              <span slot="automatic" slot-scope="{row}">
                <va-popover
                  v-if="row.automatic !== null && row.automatic === true"
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.device')">
                  <i class="fa fa-tablet"/>
                </va-popover>
                <va-popover
                  v-else
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.manual')">
                  <i class="fa fa-pencil"/>
                </va-popover>
              </span>
              <div slot="actions" slot-scope="{row}" class="text-center">
                <va-popover :message="$t('dashboard_new_evollu.measurements.delete_measurement')" placement="left" v-if="canDeleteMeasurement">
                  <i class="fa fa-times-circle p-2" @click.prevent.stop="onClickDeleteMeasurement(row)"></i>
                </va-popover>
              </div>
            </v-client-table>

            <div v-if="tabValue===1">
              <div class="chart-wrapper">
                <va-chart class="chart" :data="graphData" :options="chartOptions" type="line"/>
              </div>
            </div>
          </va-card>
        </div>
      </div>

    <ConfirmationModal
      v-if="isDeletingMeasurement"
      :title="$t('dashboard_new_evollu.measurements.delete_measurement')"
      :body="$t('dashboard_new_evollu.measurements.modal_delete_measurement', {created: selectedMeasurementToDelete.created_at})"
      okClass="btn-danger"
      @modal-confirmed="onConfirmDeleteMeasurement"
      @modal-canceled="onCancelDeleteMeasurement"
    >
    </ConfirmationModal>

    <ProfileModal
      v-if="showProfileModal"
      :measurement="selectedMeasurement"
      :patientDetails="patientDetails"
      :measurementTitle="measurementTitle"
      @cancel="onCancelProfileModal">
    </ProfileModal>
  </div>
</template>

<script>
import { ClientTable } from 'vue-tables-2'
import Vue from "vue";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import ProfileModal from "@/components/checkup_plus/patients/ParametersDetails/ProfileModal.vue";
import {OneCareService} from "@/api/OneCareService";
Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  name: "TableAndGraphCard",
  components: {
    ClientTable,
    ConfirmationModal,
    ProfileModal,
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    graphOptions: {
      required: false,
    },
    graphData: {
      required: true,
      type: Object
    },
    statsData: {
      required: true,
      type: Object
    },
    hideMaxAvgMin: {
      type: Boolean,
      default: false,
      required: false
    },
    canDeleteMeasurement: {type: Boolean, default: false, required: true},
    allowShowProfileModal: {
      type: Boolean,
      default: false,
    },
    patientDetails: {
      type: Object,
      required: false
    },
    measurementTitle: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      tabValue: 0,
      viewType: ['table', 'graph'],
      showProfileModal: false,
      tableOptions: {
        sortable: [],
        filterable: false,
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          notes: this.$t('dashboard_new_evollu.parameters.titles.notes'),
          systolic: this.$t('dashboard_new_evollu.measurement_types.systolic_short'),
          diastolic: this.$t('dashboard_new_evollu.measurement_types.diastolic_short'),
          heart_rate: this.$t('dashboard_new_evollu.measurement_types.heart_rate_short'),
          duration_session: this.$t('dashboard_new_evollu.measurement_types.duration_session_short'),
          oximetry_max: this.$t('dashboard_new_evollu.measurement_types.oximetry_max_short'),
          oximetry_min: this.$t('dashboard_new_evollu.measurement_types.oximetry_min_short'),
          oximetry_avg: this.$t('dashboard_new_evollu.measurement_types.oximetry_avg_short'),
          pulse_rate_max: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short'),
          pulse_rate_min: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short'),
          pulse_rate_avg: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short'),
          body_temperature: this.$t('dashboard_new_evollu.measurement_types.body_temperature'),
          forced_expiratory_volume_6_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short'),
          forced_expiratory_volume_1_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short'),
          fev1_fev6: this.$t('dashboard_new_evollu.measurement_types.fev1_fev6_short'),
          forced_mid_expiratory_flow_25_75: this.$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short'),
          body_weight: this.$t('dashboard_new_evollu.measurement_types.body_weight_short'),
          body_mass_index: this.$t('dashboard_new_evollu.measurement_types.body_mass_index_short'),
          body_water_percentage: this.$t('dashboard_new_evollu.measurement_types.body_water_percentage_short'),
          body_fat_percentage: this.$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short'),
          body_muscle_mass: this.$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short'),
          frailty_accessment_result: this.$t('dashboard_new_evollu.measurement_types.frailty_accessment_result_short'),
          frailty_exhaustion_result: this.$t('dashboard_new_evollu.measurement_types.frailty_exhaustion_result_short'),
          frailty_physical_activity: this.$t('dashboard_new_evollu.measurement_types.frailty_physical_activity_short'),
          frailty_walk_time: this.$t('dashboard_new_evollu.measurement_types.frailty_walk_time_short'),
          frailty_dominant_strength: this.$t('dashboard_new_evollu.measurement_types.frailty_dominant_strength_short'),
          frailty_weight_loss: this.$t('dashboard_new_evollu.measurement_types.frailty_weight_loss_short'),
          sarc_f: this.$t('dashboard_new_evollu.measurement_types.sarc_f_short'),
          hand_grip: this.$t('dashboard_new_evollu.measurement_types.hand_grip_short'),
          gait_speed: this.$t('dashboard_new_evollu.measurement_types.gait_speed_short'),
          sarc_result: this.$t('dashboard_new_evollu.measurement_types.sarc_result_short'),
          fasting: this.$t('dashboard_new_evollu.measurement_types.fasting_short'),
          blood_glucose: this.$t('dashboard_new_evollu.measurement_types.blood_glucose_short'),
          actions: this.$t('tables.columns.actions'),
          cholesterol_total: this.$t('dashboard_new_evollu.measurement_types.cholesterol_total'),
          hdl_cholesterol: this.$t('dashboard_new_evollu.measurement_types.hdl_cholesterol'),
          ldl_cholesterol: this.$t('dashboard_new_evollu.measurement_types.ldl_cholesterol'),
          triglycerides: this.$t('dashboard_new_evollu.measurement_types.triglycerides'),
          automatic: this.$t('checkup_plus.person.measurements.automatic')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        pagination: {
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          actions: 'actions',
          automatic: 'actions'
        }
      },
      isDeletingMeasurement: false,
      selectedMeasurementToDelete: null,
      selectedMeasurement: null
    }
  },
  created() {

  },
  computed: {
    chartOptions: function () {
      let options = {
        height: 55,
        legend: {
          display: true,
          position: 'bottom'
        },
        tooltips: {
          enabled: true
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero:true
            }
          }]
        },
        onClick: (evt, elementClicked) => {
          if (elementClicked.length > 0) {
            const idx = elementClicked[0]._index
            const measurement = this.data[idx]
            if (this.allowShowProfileModal && measurement.measurementSeries !== null && measurement.measurementSeries.length > 0) {
              this.selectedMeasurement = measurement
              this.showProfileModal = true
            } else {
              this.showToast(this.$t('dashboard_new_evollu.measurements.no_profile'), this.$store.state.errorToastOptions)
            }
          }
        }
      }
      if (this.graphOptions !== undefined && this.graphOptions !== null) {
        Object.assign(options, this.graphOptions)
      }
      return options
    },
    actionsAddedToColumns: function() {
      if (!this.columns.includes('actions')) {
        this.columns.push('actions')
      }
      return this.columns
    }
  },
  methods: {
    handleShowProfileModal: function ({row}) {
      if(this.allowShowProfileModal && row.measurementSeries !== null && row.measurementSeries.length > 0) {
        this.selectedMeasurement = row
        this.showProfileModal = true
      } else {
        this.showToast(this.$t('dashboard_new_evollu.measurements.no_profile'), this.$store.state.errorToastOptions)
      }
    },
    onCancelProfileModal: function () {
      this.selectedMeasurement = null
      this.showProfileModal = false
    },
    onClickDeleteMeasurement: function (measurement) {
      this.isDeletingMeasurement = true
      this.selectedMeasurementToDelete = measurement
    },
    onConfirmDeleteMeasurement: function () {
      OneCareService.deleteMeasurement(this.selectedMeasurementToDelete.id)
        .then(response => {
          this.showToast(this.$t('dashboard_new_evollu.measurements.successful_delete'), this.$store.state.successToastOptions)
          this.$emit('update_measurement', this.selectedMeasurementToDelete.measurementTypeId)
          this.onCancelDeleteMeasurement()
        })
        .catch(errors => {
          this.showToast(this.$t('dashboard_new_evollu.measurements.something_went_wrong'), this.$store.state.errorToastOptions)
          console.error(errors)
        })
    },
    onCancelDeleteMeasurement: function () {
      this.isDeletingMeasurement = false
      this.selectedMeasurementToDelete = null
    },
  }
}
</script>
<style scoped lang="scss">
.chart{
  canvas{
    width:1000px !important;
    height:600px !important;
  }
}

.chart-wrapper {
  max-width: 98%;
  width: 100%;
  height: 400px;
  margin-top: 1rem;
  margin-bottom: 0.4rem;
  margin-right: 7.5%;
}
</style>
<style lang="scss">
.actions {
  text-align: center;
}
</style>
